(function (sb) {
	var me = (sb.HeatMapCache = {});
	var heatMapDataCache = {};

	me.setHeatMapDataToCache = function (data, id) {
		heatMapDataCache[id] = data;
	};
	me.getHeatMapDataFromCache = function (id) {
		return heatMapDataCache[id];
	};
})(window.Storyboard = (window.Storyboard || {}));

window.HeatMapRenderer = {
	eventUpdateHeatMap: function (layoutElement, heatMapData) {
		var itemTypes = Storyboard.Constants.itemTypes;
		var hmElem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.HEATMAP, layoutElement);
		var hmDiv = $(".layoutElementItem[guid='" + hmElem.guid + "']");

		this.renderHeatMap(hmDiv, heatMapData, hmElem.guid);
	},

	renderHeatMap: function (hmDiv, heatMapData, elementItemGuid) {
		$(hmDiv).empty();

		if (elementItemGuid)
			Storyboard.HeatMapCache.setHeatMapDataToCache(heatMapData, elementItemGuid);

		var heatmapSettings = heatMapData.heatMapOptions;
		if (heatMapData == null || heatmapSettings == null || heatmapSettings.dataSet == null) {
			$(hmDiv).html("No Data");
		} else {
			var config = heatmapSettings.config;
			var heatmapHtml = "<table class='tblHeatmap' cellpadding='0' cellspacing='0'>";
			var yAxisItemsNum = heatmapSettings.yAxisLabels.length;
			var xAxisItemsNum = heatmapSettings.xAxisLabels.length;

			if (heatmapSettings.config.legend && heatmapSettings.config.legend.position != 'none' && 
				heatmapSettings.config.legend.position.charAt(0) == 't') {
				heatmapHtml += "<tr><td class='legendCell' colspan='" + (xAxisItemsNum + 2) + "'></td></tr>";
			}

			var yAxisTitle = heatmapSettings.yAxisTitle ? "<p>" + heatmapSettings.yAxisTitle + "</p>" : '';
			// create table
			for (var i = 0; i < yAxisItemsNum; i++) {
				heatmapHtml +=
					"<tr>" + (i == 0 ?
						"<td class='yAxisTitleCell' rowspan='" + yAxisItemsNum + "'>" + yAxisTitle + "</td>" : "") + // y axis title cell
						"<td class='yAxis'>" + heatmapSettings.yAxisLabels[i] + "&nbsp;</td>" + (i == 0 ? 								// y axis labels
						"<td id='tdHeatmapContent' colspan='" + xAxisItemsNum + "' rowspan='" + yAxisItemsNum + "'></td>" : "") + // heat map content cell
					"</tr>";
			}

			heatmapHtml += "<tr><td id='tdCorner' colspan='2' rowspan='2'></td>";
			for (i = 0; i < xAxisItemsNum; i++) {
				heatmapHtml += "<td class='xAxis'>" + heatmapSettings.xAxisLabels[i] + "&nbsp;</td>";
			}
			heatmapHtml += "</tr><tr><td class='xAxisTitleCell' colspan='" + xAxisItemsNum + "'>" + heatmapSettings.xAxisTitle + "</td></td></tr>";

			if (heatmapSettings.config.legend && heatmapSettings.config.legend.position != 'none' && 
				heatmapSettings.config.legend.position.charAt(0) == 'b') {
				heatmapHtml += "<tr><td class='legendCell' colspan='" + (xAxisItemsNum + 2) + "'></td></tr>";
			}

			var warningText = "";
			if (heatmapSettings.warningTexts.length > 0) {
				var warningTextArr = [];
				for (i = 0; i < heatmapSettings.warningTexts.length; i++)
					warningTextArr.push(heatmapSettings.warningTexts[i]);

				if (warningTextArr.length > 0)
					warningText = warningTextArr.join(',');
			}

			heatmapHtml += "<tr class='warningsRow'><td colspan='" + (xAxisItemsNum + 2) + "'>" + warningText + "</td></tr>";
			heatmapHtml += "</table>";
			$(hmDiv).html(heatmapHtml);
			config.element = $(hmDiv).find("#tdHeatmapContent")[0];

			if (heatmapSettings.yAxisTitle)
				$(hmDiv).find(".yAxisTitleCell").width("20px");

			if (heatmapSettings.config.legend) {
				// set heatMap - we need to measure legend
				var hm = h337.create(config);
				hm.store.setDataSet(heatmapSettings.dataSet);
				$(hmDiv).find(".legendCell").height($(hmDiv).find("#tdHeatmapContent > div").height() + 22); // borders, padding & top/bottom
			}

			// measure cells
			var maxCellHeight = ($(hmDiv).height() - $(hmDiv).find("#tdCorner").height() -
				$(hmDiv).find(".warningsRow").height() - $(hmDiv).find(".legendCell").height()) / yAxisItemsNum;
			var maxCellWidth = ($(hmDiv).width() - $(hmDiv).find("#tdCorner").width()) / xAxisItemsNum;
			var cellSize = Math.min(maxCellHeight, maxCellWidth);

			$(hmDiv).find("td.yAxis").each(function () { $(this).height(cellSize); });
			$(hmDiv).find("td.xAxis").each(function () { $(this).width(cellSize); });

			$(hmDiv).find("#tdHeatmapContent").width(cellSize * xAxisItemsNum);
			$(hmDiv).find("#tdHeatmapContent").height(cellSize * yAxisItemsNum);

			if (!config.radius || config.radius == 0)
				config.radius = cellSize / 2; // auto

			var gradient = {};
			if (!config.gradientStops || config.gradientStops.length < 1)
				gradient = null; // auto
			else {
				$(config.gradientStops).each(function () {
					gradient[(this.StopValue / 100)] = this.Color;
				});
			}

			config.gradient = gradient;

			$(hmDiv).find("#tdHeatmapContent").empty();
			var heatmap = h337.create(config);

			// adjust data points' position
			$(heatmapSettings.dataSet.data).each(function () {
				this.x = this.x * cellSize - cellSize / 2;
				this.y = this.y * cellSize - cellSize / 2;
			});
			heatmap.store.setDataSet(heatmapSettings.dataSet);
			$(hmDiv).find('canvas').css('left', $(hmDiv).find("#tdCorner").width());
			if (heatmapSettings.config.legend && heatmapSettings.config.legend.position.charAt(0) == 't') {
				$(hmDiv).find('canvas').css('top', $(hmDiv).find(".legendCell").height());
			}
			$(hmDiv).find('canvas').css('z-index', 1);

			if ($(hmDiv).find("#tdHeatmapContent div").length > 1) {
				this.fixLegend(heatmapSettings.config.legend.position, hmDiv);
			}
		}
	},

	fixLegend: function (position, hmDiv) {
		var legend = $(hmDiv).find("#tdHeatmapContent > div").detach();
		legend.css("position", "relative");
		legend.css("top", "auto");
		legend.css("bottom", "auto");
		legend.css("left", "auto");
		legend.css("right", "auto");
		legend.css('z-index', 1);
		if (position.charAt(1) == 'r')
			legend.css("float", "right");
		$(hmDiv).find('.legendCell').append(legend);
	},

	redrawHeatMap: function (heatMapElementItem) {
		if (heatMapElementItem != null) {
			heatMapElementItem.content = '';
			$('#' + heatMapElementItem.guid).html('');
			if (heatMapElementItem.guid != "") { //element already has been saved
				var heatMapData = Storyboard.HeatMapCache.getHeatMapDataFromCache(heatMapElementItem.guid);
				if ((typeof heatMapData != 'undefined') && (heatMapData != null)) {
					var hmDiv = $(".layoutElementItem[guid='" + heatMapElementItem.guid + "']");
					this.renderHeatMap(hmDiv, heatMapData, heatMapElementItem.guid);
				}
			}
		}
	}
};


(function (qs) {

    function init(dataGroup) {

        if (qs.isLoaded === true) {
            updateFiltersList();
        } else {
            createQuickSetupTab();
            updateFiltersList();
            bindDragAndDropEvents();
            
            qs.isLoaded = true;
        }
    }

    function destroy() {
        $('#setupChart #tabholder .ui-tabs-quicksetup').remove();
        $('#setupChart #tabholder > ul.tabs li:first-child').show();
        $('#qsLegend > .settingsFieldsetContent > .settingsBoxFull').prependTo('#variableSelection');
        $('#answerbox, #questionBox').css('display', '');
        $('#ddlAxisSort_placeholder').replaceWith($('#ddlAxisSort').parent().removeClass('DUI-OptionsPopup').css("display", ""));
        $('#ddlLegendSort_placeholder').replaceWith($('#ddlLegendSort').parent().removeClass('DUI-OptionsPopup').css('display', ''));

        $(['#quickSetup',
        '#qsLegend',
        '#qsYAxis',
        '#qsXAxis',
        '#questionBoxList',
        '#answerboxList',
        '#legendInfoText',
        ].join(',')).remove();

        $('#ddlInterval').unbind('change.QuickSetup');
        $("#tabholder").unbind('tabsshow.QuickSetup');
        $("#answerbox").unbind('change.QuickSelect');

        $('.qs-draggable-item').remove();

        qs.isLoaded = false;
    }

    function createQuickSetupTab() {
        $('#setupChart #tabholder > ul.tabs li:first-child').hide();
        $('#setupChart #tabholder > ul.tabs').prepend('<li class="ui-tabs-quicksetup"><a href="#quickSetup">Create</a></li>');
        $('#setupChart #panels').prepend('<div id="quickSetup" class="settingsPanel">'+
            '<fieldset id="qsLegend" class="settingsFieldset collapsable" data-collapse-group="#quickSetup">'+
                '<div class="settingsFieldsetLegend advanced">'+ locale.get('Legend') + '<i class="icon-collapse"></i></div>'+
                '<div class="settingsFieldsetContent expandableContent"></div>'+
            '</fieldset>'+
            '<fieldset id="qsAxes" class="settingsFieldset expandable" data-collapse-group="#quickSetup">'+
                '<div class="settingsFieldsetLegend advanced">'+ locale.get('Axis') + '<i class="icon-collapse"></i></div>'+
                '<div class="settingsFieldsetContent expandableContent">'+
                    '<div class="settingItem">'+
                        '<ul id="qsAxisList" class="qs-drop-zone"></ul>'+
                        '<p id="axisInfoText" class="Message"></p>'+
                    '</div>'+
                '</div>'+
            '</fieldset>'+
        '</div>');

        $('#setupChart #chartPreview').before('<div id="qsLegend"><div class="hHeatMapLegendTitle">' + locale.get('Legend') + '</div><ul id="qsLegendDropzone" class="qsLegendConnect qs-drop-zone qs-drop-zone-top"></ul></div>');
        
        $('#setupChart #chartPreview').before('<div id="qsYAxis"><div class="hHeatMapYAxisTitle">' + locale.get('Y Axis') + '<a id="ddlLegendSortButton" class="DUIButtonGray">'+ locale.get('Sort Y Axis') + '</a></div><ul id="qsYAxisDropzone" class="qsAxisGroupingsConnect qs-drop-zone qs-drop-zone-left"></ul></div>');
        
        $('#setupChart #chartPreview').after('<div id="qsXAxis"><ul id="qsXAxisDropzone" class="qsAxisGroupingsConnect qs-drop-zone qs-drop-zone-bottom"></ul><div class="hHeatMapXAxisTitle"><a id="ddlAxisSortButton" class="DUIButtonGray">'+ locale.get('Sort X Axis') + '</a>'+ locale.get('X Axis') + '</div></div>');

        $('#variableSelection .settingsBoxFull').appendTo('#qsLegend > .settingsFieldsetContent');

        $('#questionBox').after('<ul id="questionBoxList" class="qsLegendConnect qs-drop-zone">');
        
        $('#answerbox').bind('change.QuickSelect', updateLegendDropZone)
                       .after('<ul id="answerboxList" class="qsLegendConnect qs-drop-zone">')
                       .parent().after('<p id="legendInfoText" class="Message Message-simple"></p>');
                       

        $("#ddlAxisSort").parent()
                        .after('<span id="ddlAxisSort_placeholder"></span>')
                        .addClass("DUI-OptionsPopup").insertBefore($("#qsXAxisDropzone"));
        
        $("#ddlLegendSort").parent()
                        .after('<span id="ddlLegendSort_placeholder"></span>')
                        .addClass("DUI-OptionsPopup").insertBefore($("#qsYAxisDropzone"));
        
        $("#ddlLegendSortButton").bind("click", function(e) { 
            e.stopPropagation(); 
            $("#ddlLegendSort").parent().toggle(); 
        });
        $("#ddlAxisSortButton").bind("click", function(e) { 
            e.stopPropagation(); 
            $("#ddlAxisSort").parent().toggle(); 
        });
                
        $('#vsFilterPanelWrapper, #qbFilterPanelWrapper').css('display', 'none');
    }
    
    var qsAGCcfg = {
        zIndex: 2000,
        opacity: 0.85,
        appendTo: '#tabholder',
        connectToSortable: '.qsAxisGroupingsConnect',
        helper: function(){ return $(this).clone().css('width', $(this).width()); },
        start: function() { qsAxisDropZonesHover(true); },
        stop: function() { qsAxisDropZonesHover(false); }
    };

    var qsLGCcfg = {
        zIndex: 2000,
        opacity: 0.85,
        appendTo: '#tabholder',
        helper: function(){ return $(this).clone().css('width', $(this).width()); }
    };
    
    function qsAxisDropZonesHover(toggle) {
        $('#qsYAxisDropzone, #qsXAxisDropzone').toggleClass('qs-drop-hover', toggle);
    }
    
    function bindDragAndDropEvents() {

        var newFilter = false;

        $('#qsYAxisDropzone, #qsXAxisDropzone').sortable({
            connectWith: ".qsAxisGroupingsConnect",
            appendTo: '#tabholder',
            helper: 'clone',
            tolerance: 'pointer',
            zIndex: 2000,
            opacity: 0.85,
            receive: function (event, ui) {
                var targetAxis = parseInt($(this).attr('data-axis'), 10);

                if (ui.sender[0].id === 'qsYAxisDropzone' || ui.sender[0].id === 'qsXAxisDropzone') {
                    ChartSetupUI.dragItems(event, ui, targetAxis);
                    ChartSetupUI.changeOrderDrag(event, ui);
                } else {
                    var filterId = ui.item.attr('data-value');
                    ui.item.bind('dragstop', function(event, ui) { selectFilter(filterId, targetAxis); });
                    newFilter = true;
                }
            },
            update: function (event, ui) {
                if (this === ui.item.parent()[0] && newFilter === false) {
                    ChartSetupUI.changeOrderDrag(event, ui);
                }
                newFilter = false;
            },
            start: function() { qsAxisDropZonesHover(true); },
            stop: function() { qsAxisDropZonesHover(false); }
        });

        $('#qsAxisList').droppable({
            accept: '#qsYAxisDropzone .qs-draggable-item:not([data-value="timeperiod"]), #qsXAxisDropzone .qs-draggable-item:not([data-value="timeperiod"])',
            hoverClass: 'qs-drop-hover',
            activeClass: 'qs-drop-hover',
            drop: function (event, ui) {
                var filterId = ui.draggable.attr('data-value');
                setTimeout(function() { deselectFilter(filterId); }, 1);
            }
        });

        $('#qsLegendDropzone').droppable({
            accept: '#questionBoxList .qs-draggable-item, #answerboxList .qs-draggable-item',
            hoverClass: 'qs-drop-hover',
            activeClass: 'qs-drop-hover',
            drop: function (event, ui) {
                var currentItems = $(this).find('.qs-draggable-item');
                var legendSelectable = ui.draggable.parent();
                
                setTimeout(function() { 
                    HTMLHelpers.setSelectedValues("#"+legendSelectable.prev()[0].id, ui.draggable.attr('data-value'));
                    legendSelectable.prev().trigger("change");

                    if (currentItems.length > 0) {
                        if (legendSelectable[0].id == "questionBoxList") updateQuestionsList();
                        if (legendSelectable[0].id == "answerboxList") updateAnswersList();
                    } 
                }, 1);
                
            }
        });

        $('#questionBoxList, #answerboxList').droppable({
            accept: '#qsLegendDropzone .qs-draggable-item',
            hoverClass: 'qs-drop-hover',
            activeClass: 'qs-drop-hover',
            drop: function (event, ui) {
                HTMLHelpers.setSelectedValues("#"+$(this).prev()[0].id, -1);
                $(this).prev().trigger("change");

                if ($(this).attr('id') == "questionBoxList") updateQuestionsList();
                if ($(this).attr('id') == "answerboxList") updateAnswersList();

                ui.helper.remove();
                ui.draggable.remove();
            }
        });

    }

    function setupLegendSelections(showAnswer) {
        if (showAnswer) {
            var legendInfoText = locale.get('Drag and drop one Answer to legend');
        } else {
            var legendInfoText = locale.get('Drag and drop one Question to legend');
        }

        $('#legendInfoText').text(legendInfoText);

        $('#questionBox').toggle(!!showAnswer);
        $('#questionBoxList').toggle(!showAnswer);
        $('#answerbox').toggle(!showAnswer);
    }

    function updateQuestionsList(questionArray) {
        
        if (questionArray === undefined) {
            questionArray = $('#questionBox option:not(:selected)').map(function() {
                return {
                    questionId: this.value,
                    questionText: this.innerHTML
                };
            }).get();
        }
        
        HTMLHelpers.bindUL('#questionBoxList', questionArray, 'questionId', 'questionText', 'questionText', 'qs-draggable-item');
        $('#questionBoxList').find(".qs-draggable-item").draggable(qsLGCcfg);
        
        updateLegendDropZone();
    }

    function updateAnswersList(answerArray) {
        
        if (answerArray === undefined) {
            answerArray = $('#answerbox option:not(:selected)').map(function() {
                return {
                    answerId: this.value,
                    answerText: this.innerHTML
                };
            }).get();
        }
        
        HTMLHelpers.bindUL('#answerboxList', answerArray, 'answerId', 'answerText', 'answerText', 'qs-draggable-item');
        $('#answerboxList').find(".qs-draggable-item").draggable(qsLGCcfg);
        
        updateLegendDropZone();
    }

    function updateLegendDropZone() {
        
        var calculationType = $('#ddlCalculationType option:selected').val();
        var updateBox = (Storyboard.Constants.CalculationTypes.isAnswerBased(calculationType) === true ? "#answerbox" : "#questionBox");

        var selectedItems = $(updateBox).find('option:selected').map(function() {
                $(updateBox+"List").find('li[data-value="'+ this.value +'"').remove();
                return {
                    selectedId: this.value,
                    selectedText: (updateBox == '#answerbox' ? $('#questionBox option:selected').text() + ' (' + this.innerHTML + ')' : this.innerHTML)
                };
            }).get();

        $("#qsLegendDropzone > li").remove();

        if (selectedItems.length > 0) {
            HTMLHelpers.bindUL("#qsLegendDropzone", selectedItems, 'selectedId', 'selectedText', 'selectedText', 'qs-draggable-item');
            $('#qsLegendDropzone .qs-draggable-item').draggable(qsLGCcfg);
        }

        ChartSetupUI.updateHeatMapLegendBox();
    }

    function updateAxesDropZones(dataGroup) {
        
        var dropZones = [
            {
                dropZoneId: 'qsYAxisDropzone',
                axisPosition: Storyboard.Constants.Axis.legend
                
            },
            {
                dropZoneId: 'qsXAxisDropzone',
                axisPosition: Storyboard.Constants.Axis.axis,
            }
        ];
        var allGroupings = dataGroup.groupedItems;

        $(dropZones).each(function (i, v) {
            var zoneItems = $.grep(allGroupings, function (e, i) {
                return e.position == v.axisPosition;
            });

            HTMLHelpers.bindUL('#'+v.dropZoneId, zoneItems, 'value', 'text', 'text', 'qs-draggable-item');
            $('#'+v.dropZoneId).attr('data-axis', v.axisPosition);
        });

        if (dataGroup.isMain) setIntervalSelect();
    }
    
    function setIntervalSelect() {
        var ddlInterval = $('#ddlInterval').bind('change.QuickSetup', function() {
            $("#qsIntervalSelect").val($(this).val());
        });

        $( "<select/>", {
            "id": "qsIntervalSelect",
            html: ddlInterval.find("option").clone(),
            val: ddlInterval.val(),
            change: function() {
                ddlInterval.val($(this).val());
            }
        }).appendTo('.qsAxisGroupingsConnect li[data-value="timeperiod"]');
    }

    function updateFiltersList() {
        var filtersItems = $('#filterBox .settingItemBlock').not('.filterboxTemplate'),
            filtersArray;
        
        if (filtersItems.length > 0) {
            filtersArray = filtersItems.map(function() {
                if ($(this).find("#chkCompare").attr("checked")) return;

                return {
                    filterId: $(this).find("#hidFilterId").val(),
                    filterText: $.trim($(this).find(".filterboxHeaderWrapper h3").text())
                };
            }).get();
            
            HTMLHelpers.bindUL('#qsAxisList', filtersArray, 'filterId', 'filterText', 'filterText', 'qs-draggable-item');
            $('#qsAxisList .qs-draggable-item').draggable(qsAGCcfg);
            $('#axisInfoText').removeClass('Messsage-info').addClass('Message-simple').text(locale.get('Drag and drop to Axes'));
            
        } else {
            $('#axisInfoText').removeClass('Messsage-simple').addClass('Message-info').text(locale.get('First apply filters to drag and drop'));
        }
    }

    function selectFilter(filterId, targetAxis) {
        var filterbox = $("#filterBox div #hidFilterId[value='" + filterId + "']").parent();

        filterbox.find('.filterboxHeaderWrapper + select > option:not([value="0"])').attr("selected","selected").trigger('change');
        filterbox.find('[id="chkCompare"]').attr("checked","checked");

        ChartSetupUI.addFilterToGrouping(filterbox.find('#chkCompare'), targetAxis);
    }

    function deselectFilter(filterId) {
        var filterbox = $("#filterBox div #hidFilterId[value='" + filterId + "']").parent();

        HTMLHelpers.setSelectedValues(filterbox.find('.filterboxHeaderWrapper + select'), 0);
        filterbox.find('.filterboxHeaderWrapper + select').trigger('change');
    }

    qs.init = init,
    qs.destroy = destroy,
    qs.updateQuestionsList = updateQuestionsList,
    qs.updateAnswersList = updateAnswersList,
    qs.updateLegendDropZone = updateLegendDropZone,
    qs.updateAxesDropZones = updateAxesDropZones,
    qs.updateFiltersList = updateFiltersList,
    qs.setupLegendSelections = setupLegendSelections

})(window.HeatMapQuickSetup = (window.HeatMapQuickSetup || {}));